/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournament_Wiz_Tip_Latecomers_TInputs */



/**
* | output |
* | --- |
* | "Latecomers are fine" |
*
* @param {Tournament_Wiz_Tip_Latecomers_TInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_wiz_tip_latecomers_t = /** @type {((inputs?: Tournament_Wiz_Tip_Latecomers_TInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_Wiz_Tip_Latecomers_TInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Les retardataires sont les bienvenus")
	if (locale === "es") return /** @type {LocalizedString} */ ("Los rezagados no son problema")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Atrasados não são problema")
	if (locale === "it") return /** @type {LocalizedString} */ ("I ritardatari non sono un problema")
	return /** @type {LocalizedString} */ ("Latecomers are fine")
});